<div class="error-state-container">
  <c11n-banner
    variant="error"
    size="large"
    [headingText]="heading"
    [hasCloseControl]=false
  >
    <p>{{ content }}</p>
  </c11n-banner>
</div>
